/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SubscriptionPackageProjectData } from './SubscriptionPackageProjectData';
import {
    SubscriptionPackageProjectDataFromJSON,
    SubscriptionPackageProjectDataFromJSONTyped,
    SubscriptionPackageProjectDataToJSON,
    SubscriptionPackageProjectDataToJSONTyped,
} from './SubscriptionPackageProjectData';
import type { SubscriptionPackage } from './SubscriptionPackage';
import {
    SubscriptionPackageFromJSON,
    SubscriptionPackageFromJSONTyped,
    SubscriptionPackageToJSON,
    SubscriptionPackageToJSONTyped,
} from './SubscriptionPackage';

/**
 * 
 * @export
 * @interface SubscriptionPackageAdminData
 */
export interface SubscriptionPackageAdminData {
    /**
     * 
     * @type {SubscriptionPackage}
     * @memberof SubscriptionPackageAdminData
     */
    _package?: SubscriptionPackage;
    /**
     * 
     * @type {Array<string>}
     * @memberof SubscriptionPackageAdminData
     */
    currentProjects?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof SubscriptionPackageAdminData
     */
    nextProjects?: Array<string>;
    /**
     * 
     * @type {Array<SubscriptionPackageProjectData>}
     * @memberof SubscriptionPackageAdminData
     */
    availableForProjects?: Array<SubscriptionPackageProjectData>;
    /**
     * 
     * @type {number}
     * @memberof SubscriptionPackageAdminData
     */
    usageCount?: number;
    /**
     * Internal administrator note.
     * @type {string}
     * @memberof SubscriptionPackageAdminData
     */
    internalNote?: string | null;
    /**
     * Whether the package has no subscription or subscription-history references and can be deleted.
     * @type {boolean}
     * @memberof SubscriptionPackageAdminData
     */
    canDelete?: boolean;
}

/**
 * Check if a given object implements the SubscriptionPackageAdminData interface.
 */
export function instanceOfSubscriptionPackageAdminData(value: object): value is SubscriptionPackageAdminData {
    return true;
}

export function SubscriptionPackageAdminDataFromJSON(json: any): SubscriptionPackageAdminData {
    return SubscriptionPackageAdminDataFromJSONTyped(json, false);
}

export function SubscriptionPackageAdminDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionPackageAdminData {
    if (json == null) {
        return json;
    }
    return {
        
        '_package': json['package'] == null ? undefined : SubscriptionPackageFromJSON(json['package']),
        'currentProjects': json['currentProjects'] == null ? undefined : json['currentProjects'],
        'nextProjects': json['nextProjects'] == null ? undefined : json['nextProjects'],
        'availableForProjects': json['availableForProjects'] == null ? undefined : ((json['availableForProjects'] as Array<any>).map(SubscriptionPackageProjectDataFromJSON)),
        'usageCount': json['usageCount'] == null ? undefined : json['usageCount'],
        'internalNote': json['internalNote'] === undefined ? undefined : json['internalNote'] === null ? null : json['internalNote'],
        'canDelete': json['canDelete'] == null ? undefined : json['canDelete'],
    };
}

export function SubscriptionPackageAdminDataToJSON(json: any): SubscriptionPackageAdminData {
    return SubscriptionPackageAdminDataToJSONTyped(json, false);
}

export function SubscriptionPackageAdminDataToJSONTyped(value?: SubscriptionPackageAdminData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'package': SubscriptionPackageToJSON(value['_package']),
        'currentProjects': value['currentProjects'],
        'nextProjects': value['nextProjects'],
        'availableForProjects': value['availableForProjects'] == null ? undefined : ((value['availableForProjects'] as Array<any>).map(SubscriptionPackageProjectDataToJSON)),
        'usageCount': value['usageCount'],
        'internalNote': value['internalNote'],
        'canDelete': value['canDelete'],
    };
}

